export class RequestHistory {
  requestId : number;
  requestStatusId: number;
  requestStatusName : string;
  remarks: string;
  eventDate: Date;
  createdBy: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/request-history.ts